import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


const RFC_5322_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}\.?$/;


/**
 * Validates that the control value is a valid email address.
 * Examples of invalid email addresses:
 * 1. admin@user
 * 2. admin@user.c
 * 3. admin@user.c12
 * 4. admin@user.com1
 *
 * @param {RegExp} pattern
 * @param {string} errorName
 * @returns {ValidatorFn}
 */
export const emailValidator = (
  pattern = RFC_5322_REGEX,
  errorName = 'email'
): ValidatorFn => {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const valid = pattern.test(value);

    return valid ? null : { [errorName]: true };
  };
};
